import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertService } from '../../../core/alerts/alert.service';

@Component({
    selector: 'app-statistik-tidsforbrug-options-periode',
    templateUrl: './statistik-tidsforbrug-options-periode.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikTidsforbrugOptionsPeriodeComponent {
    @Output() periodeChange = new EventEmitter<{fra: string, til: string}>();
    @Input() periode: {fra: string, til: string};

    constructor(
        private alert: AlertService,
    ) {}

    onFraChange(fra: string, isValidDate: boolean) {
        if (!isValidDate || !fra) { return; }
        if (!this.isValidPeriode(fra, this.periode.til)) {
            return;
        }
        this.periode.fra = fra;
        this.onPeriodeChange();
    }

    onTilChange(til: string, isValidDate: boolean) {
        if (!isValidDate || !til) { return; }
        if (!this.isValidPeriode(this.periode.fra, til)) {
            return;
        }
        this.periode.til = til;
        this.onPeriodeChange();
    }

    private isValidPeriode(fra: string, til: string) {
        if (new Date(fra) > new Date(til)) {
            this.alert.createAlert(
                'Til dato skal være større end fra dato!',
                'danger'
            );
            return false;
        }
        return true;
    }

    private onPeriodeChange() {
        if (!this.periode.fra || !this.periode.til) { return; }
        this.periodeChange.emit({fra: this.periode.fra, til: this.periode.til});
    }
}
